import { render, staticRenderFns } from "./m_info.vue?vue&type=template&id=36ac4ee8&scoped=true&"
import script from "./m_info.vue?vue&type=script&lang=js&"
export * from "./m_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ac4ee8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36ac4ee8')) {
      api.createRecord('36ac4ee8', component.options)
    } else {
      api.reload('36ac4ee8', component.options)
    }
    module.hot.accept("./m_info.vue?vue&type=template&id=36ac4ee8&scoped=true&", function () {
      api.rerender('36ac4ee8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/modifiers/items/tabs/m_info.vue"
export default component.exports